import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute, NavigationEnd, ParamMap, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Supplier } from "src/app/inventory/supplier/supplier";
import { Page } from "src/app/util/page";
import { Criteria } from "src/app/util/search/criteria/criteria";
import { FrCriteria } from "src/app/util/search/criteria/fr-criteria";
import { SearchComponent } from "src/app/util/search/search-component";
import { SearchRequest } from "src/app/util/search/search-request";
import { RmaSearchResult } from "../rma-search-result";
import { RmaService } from "../rma-service";
import { RmaSupplierSearchCriteriaComponent } from "./criteria/supplier-search-criteria.component";
import { RmaSupplierSearchComponent } from "./search-supplier/rma-supplier-search.component";

@Component({
  templateUrl: './rma-search.component.html'
})
export class RmaSearchComponent extends SearchComponent<RmaSearchResult> {
  public loading = false;
  public error = false;

  @ViewChild(RmaSupplierSearchCriteriaComponent)
  supplierCriteria!: RmaSupplierSearchCriteriaComponent;

  constructor(
    private modalService: NgbModal,
    private rmaService: RmaService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    super(new Map<string, Criteria>([
      ["supplier", new FrCriteria("Le fournisseur")]
    ]));
  }

  public addSupplierFilter(publisher: string) {
    this.addFilter("supplier", publisher);
  }

  public clearSupplier() {
    this.clearFilter("supplier");
  }

  public confirmNewRma(supplier: Supplier) {
    this.rmaService.newRmaBySupplier(supplier.id)

      .subscribe({
        next: rma => this.router.navigate(["/inventory/rma", rma.number]),
        error: _ => {
          this.loading = false;
          this.error = true;
        }
      });
  }

  public displaySupplierFilter(): string {
    return this.displayFilter("supplier");
  }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
      }
    });
  }

  ngAfterViewInit(): void {
    this.supplierCriteria.onFilterAdded().pipe(tap(supplier => this.addSupplierFilter(supplier))).subscribe();

    this.route.queryParamMap.subscribe(queryParam => setTimeout(() => this.searchWithQueryParam(queryParam)));
  }

  public onSearch(searchRequest: SearchRequest, page: number): Observable<Page<RmaSearchResult>> {
    var searchRmaRequest = {
      query: searchRequest.query,
      supplier: searchRequest.getValues("supplier"),
    };

    return this.rmaService.search(searchRmaRequest, page, 20);
  }

  public openRma(rma: RmaSearchResult) {
    this.router.navigateByUrl("/inventory/rma/" + rma.number);
  }

  public openSearchSupplierModal() {
    var modalRef = this.modalService.open(RmaSupplierSearchComponent);

    modalRef.componentInstance.onConfirm = (supplier: Supplier) => this.confirmNewRma(supplier);
    modalRef.componentInstance.applyButtonTitle = "Créer une commande";
  }

  public refresh() {
    this.router.navigate(["/inventory/rma"], { queryParams: this.getQueryParams() });
  }

  public searchWithQueryParam(paramMap: ParamMap) {
    this.initWithParamMap(paramMap);

    this.search();
  }
}